import React from 'react';
import GraphLoader from '../ContentLoaders/GraphLoader';
import { SECTION, sectionState } from '../../utils/sectionState';

// Wraps a data-driven section with the three-state behaviour:
//   loading -> a skeleton (a content-shaped `skeleton`, or a GraphLoader),
//   hidden  -> nothing at all (empty data or an error) — the whole section,
//              including its heading, is removed rather than showing "No data",
//   ready   -> the content.
//
// `children` may be a render function that receives `api.data`, or plain nodes.
const AsyncSection = ({
    api,
    isEmpty,
    skeleton,
    loaderHeight = 240,
    loaderWidth = 800,
    children,
}) => {
    const state = sectionState(api, isEmpty);
    if (state === SECTION.HIDDEN) {
        return null;
    }

    if (state === SECTION.LOADING) {
        return skeleton !== undefined
            ? skeleton
            : <GraphLoader height={loaderHeight} width={loaderWidth} />;
    }

    return typeof children === 'function' ? children(api.data) : children;
};

export default AsyncSection;
